import React, {useState} from "react";

import GroupedTestsTable from "./grouped_tests_table";
import UngroupedTestsTable from "./ungrouped_tests_table";

import {OrganisationId} from "common/types/organisation";
import {WorkflowInstanceId} from "common/flowmaster/types/workflow";
import {AggregatedWorkflowTest} from "common/flowmaster/types/test";
import {LlmRunFilterKeys} from "common/flowmaster/types/llm_run";
import {LlmRunQueryParams} from "routes/llm_run/utils/filtering/get_llm_run_query_params";

type Props = {
  organisationId: OrganisationId;
  workflowTests: AggregatedWorkflowTest[];
  filters?: LlmRunQueryParams;
  updateValue: (
    obj: Partial<Record<LlmRunFilterKeys, string | number>>,
  ) => void;
  groupResults: boolean;
};

export default function TestsTable({
  organisationId,
  workflowTests,
  updateValue,
  groupResults,
}: Props) {
  const [groupState, setGroupState] = useState<
    Record<WorkflowInstanceId, {isOpen: boolean}>
  >({});
  if (!groupResults) {
    return (
      <UngroupedTestsTable
        organisationId={organisationId}
        workflowTests={workflowTests}
        updateValue={updateValue}
      />
    );
  } else {
    return (
      <GroupedTestsTable
        organisationId={organisationId}
        workflowTests={workflowTests}
        updateValue={updateValue}
        groupState={groupState}
        toggleOpen={(id: WorkflowInstanceId) =>
          setGroupState({
            ...groupState,
            [id]: {isOpen: !groupState[id]?.isOpen},
          })
        }
      />
    );
  }
}
